import { EventEmitter, OnInit } from '@angular/core';
import { PageNames } from '../../../../shared/page-names.enum';
import { TvShopEntertainmentPack } from '../../../../model/tv-shop-entertainment-pack';
import { OrderOption } from '../../../../model/order-option';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { LanguageService } from '../../../../services/language/language.service';
import { PriceUtils } from '../../../../shared/utils/price/price.utils';
import { ImageUtils } from '../../../../shared/utils/image/image-utils';
var StandaloneFlavorOptionComponent = /** @class */ (function () {
    function StandaloneFlavorOptionComponent(navigationService, languageService) {
        this.navigationService = navigationService;
        this.languageService = languageService;
        this.ownerComponent = PageNames.STANDALONE_FLAVORS;
        this.emitOrderProduct = new EventEmitter();
        this.emitOnBack = new EventEmitter();
        this.label = 'eos-tv-shop-ii.title.standalone-flavor-options-order';
    }
    StandaloneFlavorOptionComponent.prototype.ngOnInit = function () {
        this.priceDetail = this.orderOption ? this.orderOption.priceDetail : undefined;
    };
    StandaloneFlavorOptionComponent.prototype.activate = function (active) {
        this.active = active;
    };
    Object.defineProperty(StandaloneFlavorOptionComponent.prototype, "hasPromo", {
        get: function () {
            return this.orderOption.priceDetail && this.orderOption.priceDetail.hasPromo();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StandaloneFlavorOptionComponent.prototype, "promoLabel", {
        get: function () {
            return this.orderOption.priceDetail ? this.orderOption.priceDetail.promoLabel : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StandaloneFlavorOptionComponent.prototype, "promoDuration", {
        get: function () {
            return this.orderOption.priceDetail ? this.orderOption.priceDetail.promoDuration : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StandaloneFlavorOptionComponent.prototype, "textIntegerPart", {
        get: function () {
            return this.orderOption.priceDetail ? this.orderOption.priceDetail.price.integerPart() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StandaloneFlavorOptionComponent.prototype, "textDecimalPart", {
        get: function () {
            return this.getTextDecimalPart(this.orderOption.priceDetail ? this.orderOption.priceDetail.price.decimalPart() : undefined);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StandaloneFlavorOptionComponent.prototype, "priceBeforeComma", {
        get: function () {
            return this.orderOption.priceDetail ? this.orderOption.priceDetail.promoPrice.integerPart() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StandaloneFlavorOptionComponent.prototype, "getPriceTextDecimalPart", {
        get: function () {
            return this.getTextDecimalPart(this.orderOption.priceDetail ? this.orderOption.priceDetail.promoPrice.decimalPart() : undefined);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StandaloneFlavorOptionComponent.prototype, "standAloneOptionLogoUrl", {
        get: function () {
            return ImageUtils.getLogoUrlForOmapiId(this.orderOption.omapiId + '-flavor-option');
        },
        enumerable: true,
        configurable: true
    });
    StandaloneFlavorOptionComponent.prototype.onEmitOrderProduct = function (event) {
        this.emitOrderProduct.emit(event);
    };
    StandaloneFlavorOptionComponent.prototype.onBack = function () {
        this.emitOnBack.emit();
    };
    Object.defineProperty(StandaloneFlavorOptionComponent.prototype, "getCurrentLang", {
        get: function () {
            return this.languageService.getCurrentLanguage().toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    StandaloneFlavorOptionComponent.prototype.getTextDecimalPart = function (price) {
        var sign = this.getCurrentLang === 'fr' ? ' €' : '';
        return PriceUtils.prefixDecimalPart(price, this.getCurrentLang) + sign;
    };
    return StandaloneFlavorOptionComponent;
}());
export { StandaloneFlavorOptionComponent };
